import {createContext, useContext, useState} from "react"

export class TransferStatus {
    static UNINITIALIZED = "uninitialized";
    static INITIALIZED = "initialized";
    static FAILED = "failed";
    static SUCCESS = "success"

    constructor(type) {
        this.type = type;
    }
}

export const TransferStatusContext = createContext(null)

export const TransferStatusContextProvider = ({ children }) => {
    const [transferStatus, setTransferStatus] = useState({
        status: TransferStatus.UNINITIALIZED,
        message: '',
        paidAmount: null
    });

    const [transferDetails, setTransferDetails] = useState({
        accountNumber: '',
        accountName: '',
        bankName: '',
        requestedAt: null
    })

    const loadTransferDetails = () => {
        setTransferStatus({
            status: TransferStatus.UNINITIALIZED,
            message: '',
            paidAmount: null
        })
    }

    const showTransferDetails = () => {
        setTransferStatus({
            status: TransferStatus.INITIALIZED,
            message: '',
            paidAmount: null
        })
    }

    const showFailed = (message) => {
        setTransferStatus({
            status: TransferStatus.FAILED,
            message: message,
            paidAmount: null
        })
    }

    const showSuccess = (paidAmount = null) => {
        setTransferStatus({
            status: TransferStatus.SUCCESS,
            message: '',
            paidAmount: paidAmount
        })
    }

    const setErrorMessage = (message) => {
        setTransferStatus({
            status: transferStatus.status,
            message: message,
            paidAmount: transferStatus.paidAmount
        })
    }

    const value = {transferStatus, setErrorMessage, showFailed, showSuccess, showTransferDetails, loadTransferDetails,
        transferDetails, setTransferDetails}

    return(
        <TransferStatusContext.Provider value={value}> {children} </TransferStatusContext.Provider>
    );
}

export default TransferStatusContext;

export const useTransferStatus = ()=>{
    return useContext(TransferStatusContext);
}